import { render } from "./Loading.vue?vue&type=template&id=3164400e&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=3164400e&scoped=true&lang=css"

import exportComponent from "/Users/thanhnguyen/Desktop/ThanhNguyen/projects/public_html/numbers-betting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3164400e"]])

export default __exports__